export  const DEFAULTS = {
   URL_BASE: 'https://aubiasi-server.top-secret.mx'
}
